import SpritePolySparks from './spritePolySparks';
import Entity from './entity';
import Scene from './scene';
import Utils from './utils';
import SpritePolyRipples from './spritePolyRipples';


export default class ParticleManager {

	/**
	 * Particle spawner, automatically adds display objects on the specified Layer of the specified Scene
	 * @param {Object} args
	 * @param {Scene} args.scene host Scene
	 * @param {String} args.layer [default] name of display Layer within Scene
	 */
	constructor(args) {
		this.scene = args.scene;
		this.system = args.scene.system;
		this.layer = args.layer || 'default';
		this.init();
	}

	init() {
		this.sparks = new Entity({
			name: 'particles_sparks',
			scene: this.scene,
			sprite: new SpritePolySparks({
				layer: this.layer,
				max: 2000,
			})
		});
		this.sparks.init();
		this.scene.entities.push(this.sparks);

		this.ripples = new Entity({
			name: 'particles_ripples',
			scene: this.scene,
			sprite: new SpritePolyRipples({
				layer: this.layer,
				max: 2000,
			})
		});
		this.ripples.init();
		this.scene.entities.push(this.ripples);
	}

	setGroundLevel(y) {
		this.sparks.sprite.groundY = y;
	}

	setSparkDamping(damping) {
		this.sparks.sprite.sparkDamp = damping;
	}

	/**
	 * @param {Object} args origin coordinates + base velocity (if being inherited)
	 * @param {Position} args.origin origin coordinates + base velocity (if being inherited)
	 * @param {*} args.color single color, or array of rgb hex colors eg. 0x00ff00 or [0x00ff00,0xff0000] for multicolor sparks
	 * @param {Number} args.power velocity multiplier
	 * @param {Number} args.amount total number of sparks
	 * @param {Number} args.spread period (ms) over which sparks are emitted
	 * @param {Number} args.expire average expiry time (ms)
	 * @param {Number} args.expireSlop variance in expirt time (ms)
	 * @param {Number} args.slop variance in start position from origin
	 * @param {Number} args.minSlop minimum distance (circluar) from origin (default 0)
	 * @param {Number} args.velocityInherit amount of velocity from origin to be inherited by sparks, negative values allowed (default 0)
	 */
	createSparks(args) {
		let a = {};
		a.origin = args.origin;
		a.color = args.color || 0x00bb55;
		a.power = args.power || 1;
		a.amount = args.amount || 100;
		a.spread = args.spread || 100;
		a.expire = args.expire || 350;
		a.expireSlop = args.expireSlop || 150;
		a.slop = args.slop || 0;
		a.minSlop = args.minSlop || 0;
		a.velocityInherit = args.velocityInherit || 0;
		let step = a.spread/a.amount;
		while(a.amount > 0) {
			let v = Utils.randomVector();
			v.x += a.origin.xv * a.velocityInherit;
			v.y += a.origin.yv * a.velocityInherit;
			let f = 1 - Math.pow(Math.random(), 2);
			// let f = Math.random();
			this.sparks.sprite.addSpark(
				a.origin.x + v.x * (a.minSlop + Utils.randomFloat(0, a.slop)),
				a.origin.y + v.y * (a.minSlop + Utils.randomFloat(0, a.slop)),
				v.x * f * a.power,
				v.y * f * a.power,
				Utils.fuzzyFloat(a.expire, a.expireSlop),
				0 - step * a.amount,
				typeof a.color == 'number' ? a.color : Utils.randomElement(a.color)
			);
			a.amount--;
		}
	}

	/**
	 * @param {Position} origin origin coordinates
	 * @param {Number} startRadius 
	 * @param {Number} expandRate
	 * @param {Number} expire
	 * @param {Number} offset time offset, negative values delay start
	 * @param {Number} color
	 */
	createRipple(origin, startRadius, expandRate, expire, offset, color) {
		this.ripples.sprite.addRipple(
			origin.x,
			origin.y,
			startRadius,
			expandRate,
			expire,
			offset,
			color
		);
	}

}